import { pick } from 'lodash';
import { connect } from 'react-redux';
import { branch, compose, renderNothing, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form';
import { t } from '../../../../modules/infra/i18n';
import BrandSubscriptionOptions from '../components/BrandSubscriptionOptions';
import { getInitialValuesFromBrand } from '../helpers';
import { getBrand } from '../reducers';
import { updateBrand } from '../actions';
import withNotifications from '../../../common/withNotifications';

const mapStateToProps = (state, ownProps) => ({
  initialValues: getInitialValuesFromBrand(getBrand(state, ownProps.brandId)),
});

const mapDispatchToProps = {
  updateBrand,
};

export default compose(
  branch((props) => !props.brandId, renderNothing),
  connect(mapStateToProps, mapDispatchToProps),
  withNotifications,
  withHandlers({
    onSubmit: (props) => (data) => {
      props
        .updateBrand(
          props.brandId,
          pick(data, [
            'campaignsEnabled',
            'commissionReportingEnabled',
            'productReportingEnabled',
            'customReportingEnabled',
            'chatEnabled',
            'conversionTracking',
          ])
        )
        .then(() =>
          props.addNotification({
            title: t('brand:options.success_title'),
            level: 'success',
            message: t('brand:options.update_success_message'),
          })
        );
    },
  }),
  reduxForm({
    form: 'brandSubscriptionOptions',
    enableReinitialize: true,
  })
)(BrandSubscriptionOptions);
